<template>
  <div class="question-modal">
    <div class="content">
      <div class="box">
        <div @click="hideModal()" class="close"></div>
        <h2>{{ $t('questionModal.haveQuestion') }}</h2>
        <p>{{ $t('questionModal.completeForm') }}</p>
        <div class="inputs">
          <div :class="{ error: nameError }" class="input">
            <input v-model="name" class="name" type="text" :placeholder="$t('questionModal.name')"/>
            <div class="hexagon-error"><span>!</span></div>
          </div>
          <div :class="{ error: emailError }" class="input">
            <input v-model="email" class="email" type="email" :placeholder="$t('questionModal.email')"/>
            <div class="hexagon-error"><span>!</span></div>
          </div>
        </div>
        <label :class="{ error: questionError }" class="select-box">
          <select v-model="question">
            <option value="" disabled selected>{{ $t('questionModal.queryTopicText') }}</option>
            <option value="farms">{{ $t('questionModal.queryTopic.questionOne') }}</option>
            <option value="airport">{{ $t('questionModal.queryTopic.questionTwo') }}</option>
            <option value="area">{{ $t('questionModal.queryTopic.questionThree') }}</option>
            <option>{{ $t('questionModal.queryTopic.questionFour') }}</option>
            <option>{{ $t('questionModal.queryTopic.questionFive') }}</option>
          </select>
        </label>
        <textarea :class="{ error: contentError }" v-model="content"
                  :placeholder="$t('questionModal.content')"></textarea>
        <p class="rodo">{{ $t('questionModal.rodo') }}<router-link to="/privacy-policy" @click.native="hideModal">{{ $t('questionModal.rodoLink') }}</router-link></p>
        <div class="clearfix">
          <div v-if="error" class="alert">
            <div class="hexagon-error"><span>!</span></div>
            <span class="text">{{ $t('questionModal.errorMsg') }}</span>
          </div>
          <div v-if="sendError" class="alert">
            <div class="hexagon-error"><span>!</span></div>
            <span class="text">{{ $t('questionModal.errorSendMsg') }}</span>
          </div>
          <div v-if="sendComplete" class="alert done">
            <span class="text">{{ $t('questionModal.sendMsg') }}</span>
          </div>
          <a @click="sendForm()" class="button btn orange">{{ $t('questionModal.send') }} <span/></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store/store';

export default {
  name: 'modal',
  data() {
    return {
      name: '',
      email: '',
      question: '',
      content: '',
      error: false,
      sendError: false,
      sendComplete: false,
      nameError: false,
      emailError: false,
      questionError: false,
      contentError: false
    }
  },
  mounted: function () {
    this.question = store.state.modalQuestionName;
  },
  computed: {
    isMenuOpen() {
      return store.state.isMenuOpen;
    },
    lang: () => {
      return store.state.lang;
    }
  },
  watch: {
    $route() {
      this.hideModal();
    }
  },
  methods: {
    menuToggle: () => {
      store.commit('TOGGLE_MENU');
    },
    hideModal: function () {
      store.commit('SET_MODAL', { visible: false, questionName: '' });
    },
    validateEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validateFrom: function () {
      if (this.name === '' || !this.validateEmail(this.email) || this.question === '' || this.content === '') {
        this.error = true;
      } else {
        this.error = false;
      }
      if (this.name === '') {
        this.nameError = true;
      } else {
        this.nameError = false;
      }
      if (!this.validateEmail(this.email)) {
        this.emailError = true;
      } else {
        this.emailError = false;
      }
      if (this.question === '') {
        this.questionError = true;
      } else {
        this.questionError = false;
      }
      if (this.content === '') {
        this.contentError = true;
      } else {
        this.contentError = false;
      }
      return this.error;
    },
    sendForm: function () {
      this.validateFrom();
      if (this.validateFrom()) {
        this.sendComplete = false;
        this.sendError = false;
      } else {
        var data = new FormData();
        data.append('name', this.name)
        data.append('email', this.email)
        data.append('question', this.question)
        data.append('content', this.content)
        var t = this;
        fetch('/mail.php', {
          method: 'POST',
          body: data
        }).then(
          function (response) {
            if (response.status != 200) {
              t.sendError = true;
            } else {
              t.sendError = false;
              t.sendComplete = true;
              t.name = '';
              t.email = '';
              t.question = '';
              t.content = '';
            }
          }
        );

      }
    }
  }
}
</script>

<style scoped="">
.rodo {
  margin-top: 10px;
  font-size: 10px;
  line-height: 1.3em;
}

</style>



// WEBPACK FOOTER //
// Modal.vue?fbd4598e